<script>
import api from '@/helpers/api'
import axios from 'axios'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import { v4 as uuidv4 } from 'uuid'

import gql from 'graphql-tag'
export default {
  name: 'product.info',
  props: {
    product_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    productFiles: []
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    product_id: { handler: 'onInit', immediate: true }
  },
  computed: {
    images () {
      return this.productFiles
    },
    attachments () {
      return this.productFiles
    }
  },
  methods: {
    async onInit () {
      this.isLoading = true
      let { items } = await api.productFiles.fetchPage({
        page: 1,
        pageSize: -1,
        orderBy: [{ file: { uploaded_at: 'asc' } }],
        filters: [{ product_id: { _eq: this.product_id } }]
      })
      this.productFiles = [
        ...items.map(f => ({
          ...f.file,
          name: f.file.file_name,
          size: f.file.file_size,
          type: f.file.file_content_type
        }))
      ]
      this.isLoading = false
    },

    async onFileUploaded (file) {
      if (file) {
        await api.productFiles.create({
          product_id: this.product_id,
          file_id: file.id
        })
        this.onInit()
      }
    },

    async onRemoveFileHandler (fileId) {
      try {
        await api.files.delete({
          id: fileId
        })
        this.onInit()
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title border-bottom pb-3 mb-4">
        <div class="d-flex justify-content-between align-items-center">
          Files & Images
          <div class="d-flex align-items-center">
            <b-btn
              variant="link"
              class="d-flex align-items-center"
              v-on:click="$refs['file-manager'].selectFiles('application/pdf')"
            >
              <i class="bx bxs-file-pdf font-size-18 mr-1"></i>
              Select Attachments
            </b-btn>
            <b-btn
              variant="link"
              v-on:click="$refs['file-manager'].selectFiles('image/*')"
              class="d-flex align-items-center"
            >
              <i class="bx bxs-image-add font-size-18 mr-1"></i>
              Select Images
            </b-btn>
          </div>
        </div>
      </h4>

      <div
        class="d-flex flex-wrap justify-content-start align-items-center"
      ></div>

      <app-file-manager
        ref="file-manager"
        accept="image/*"
        :max-size="5"
        :directory="`products/${product_id}`"
        v-on:file-uploaded="onFileUploaded"
        v-on:file-removed="onInit"
      >
        <template v-slot:preset>
          <template v-for="file in productFiles">
            <div
              :key="file.id"
              class="d-flex justify-items-start align-items-end p-2 border m-2 rounded-sm"
              style="width:300px;position:relative;"
            >
              <app-file-thumbnail :file="file" class="mr-2" />
              <div class="w-100">
                <div
                  class="text-truncate font-size-12"
                  style="max-width: 160px;"
                  v-b-tooltip.hover.v-primary
                  :title="file.file_name"
                >
                  {{ file.file_name }}
                </div>
                <small class="d-block">{{
                  file.file_size | prettyBytes
                }}</small>
                <small class="d-block" v-if="file.uploaded_at">
                  Uploaded
                  {{ file.uploaded_at | moment('from', 'now') }}
                </small>
              </div>
              <b-btn
                variant="link"
                size="lg"
                class="m-1 p-1"
                v-on:click="onRemoveFileHandler(file.id)"
                style="position:absolute;right:0;top:0;"
              >
                <i class="bx bx-x"></i>
              </b-btn>
            </div>
          </template>
        </template>
      </app-file-manager>
    </b-card>
  </g-overlay>
</template>
